import { Component, OnInit } from '@angular/core';
import {DynamicDialogConfig} from 'primeng/api';

@Component({
  selector: 'app-anexo-os-dialog',
  templateUrl: './anexo-os-dialog.component.html',
  styleUrls: ['./anexo-os-dialog.component.css']
})
export class AnexoOsDialogComponent implements OnInit {

  constructor(public config: DynamicDialogConfig) { }

  ngOnInit() {

    const img = document.getElementById('imagemAnexo');
    img.setAttribute('src', this.config.data);

  }

}
